export default "__VITE_ASSET__u71TVt6e__"